<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{'general.loading' | translate}}...</p>
</ngx-spinner>
<div class="col-12" id="account">
    <h2 class="page-title" tabindex="0">{{'account.subscription-details' | translate}}</h2>
    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
        </ng-container>
    </xng-breadcrumb>
    <div class="col-12">      
        <div id="account-owner">
            <div class="row">
                <div class="col-6 col-sm-12 pt-2 pr-2 pb-2 pl-0">
                    <div class="card border-top">
                        <div class="card-body">
                            <h4 class="title-color">{{'account.subscription' | translate}} 
                                <span class="plan-status mr-1" *ngIf="!subscription?.periodCanceled && !subscription?.periodTrial" >
                                    {{'account.active_subs' | translate}}
                                </span>
                                <span class="plan-canceled mr-1" *ngIf="subscription?.periodCanceled">
                                    {{'account.canceled_subs' | translate}}
                                </span>
                                <span class="plan-trial" *ngIf="subscription?.periodTrial">
                                    {{'account.trial' | translate}}
                                </span>
                            </h4>
                            <hr>
                            <div *ngIf="subscription">
                                <div class="row">
                                    <div class="col-6 sub">
                                        <strong>Id:</strong>
                                    </div>
                                    <div class="col-6 sub mw-50 text-break">
                                        {{subscription?.key}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 sub">
                                        <strong>Plan:</strong>
                                    </div>
                                    <div class="col-6 sub">
                                        {{((subscription?.planName != null)?subscription?.planName:'') | translate}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 sub">
                                        <strong>{{'subscription.created_date' | translate}}:</strong>
                                    </div>
                                    <div class="col-6 sub">
                                        {{functionsService.convertUTCDateToLocalDateOnly(subscription?.created)}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 sub">
                                        <strong>{{'roles.agents_supervisors' | translate}}:</strong>
                                    </div>
                                    <div class="col-6 sub">
                                        <strong>{{userCount?.agentSupervisor}}</strong>/{{userCount?.agentsSupervisors}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 sub">
                                        <strong>{{'roles.users' | translate}}:</strong>
                                    </div>
                                    <div class="col-6 sub">
                                        <strong>{{userCount?.user}}</strong>/{{userCount?.users}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 sub">
                                        <strong>{{'plan.video_feature' | translate}}:</strong>
                                    </div>
                                    <div class="col-6 sub">
                                        {{subscription?.includesVideo ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <strong>{{'plan.agent_dispatch' | translate}}:</strong>
                                    </div>
                                    <div class="col-6">
                                        {{subscription?.agentDispatch ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <strong>{{'plan.geo_zone_assignment' | translate}}:</strong>
                                    </div>
                                    <div class="col-6">
                                        {{subscription?.geoAssignment ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
            <div class="row">
                <div class="col-3 pt-2 pr-2 pb-2 pl-0">
                    <div class="row">
                        <div class="col-12">
                            <sub *ngIf="!subscription?.periodCanceled && !nextPeriod?.canceled && !subscription?.canceled"><a tabindex="0" (click)="cancelSubscription()" (keydown.enter)="cancelSubscription()" class="custom-hyperlink">{{'account.cancel_subscription' | translate}}</a></sub>
                        </div>
                    </div>
                    <div class="card border-top mt-2">
                        <div class="card-body">
                            <h4 class="page-title mt-0">{{'account.subscription_history' | translate}}</h4>
                            <hr class="mb-0">
                            <div class="row">
                                <div class="col-12 pl-0">
                                    <ul class="timeline" *ngFor="let s of subHistory">
                                        <li>
                                            <!---<span class="float-left m-timeline">{{functionsService.convertUTCDateToLocalDateOnly(s.date)}}</span>--->
                                            <span class="ml-2">{{functionsService.convertUTCDateToLocalDateOnly(s.date)}}</span><br>
                                            <span class="ml-2">{{((s?.typeName != null)?'account.'+s?.typeName.toLowerCase():'')| translate}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
                <div class="col-9 p-2">
                    <div class="row canceledBox p-2 mb-2" *ngIf="(subscription?.periodCanceled || nextPeriod?.canceled || subscription?.expired)">
                        <div *ngIf="remaining_days>=0 && !subscription?.expired" class="col-12">
                            {{'account.subscription_canceled1' | translate}} {{nextPeriod!=null?functionsService.convertUTCDateToLocalDateOnly(nextPeriod.endDate):functionsService.convertUTCDateToLocalDateOnly(endDate)}}. {{'account.subscription_canceled2' | translate}} <a (click)="reactivateSubscription()" class="custom-hyperlink">{{'general.click_here' | translate}}</a>.
                        </div>
                        <div *ngIf="remaining_days<=0 && subscription?.expired" class="col-12">
                            {{'account.expired_subscription' | translate}} <a routerLink="subscription-purchase" routerLinkActive="active" class="custom-hyperlink">{{'general.click_here' | translate}}</a>.
                        </div>
                    </div>
                    <div class="keepPlanBox row p-2 m-0 mb-3" *ngIf="(!nextPeriod?.paid) && (subscription?.price > nextPeriod?.price) && keep_plan">
                        <div class="col-12" id="keepMessage">
                        {{keep_plan}} <a (click)="keepCurrentPlan()" class="custom-hyperlink"><b>{{'general.click_here' | translate}}</b></a>.
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 pl-2 pr-2 pb-2">
                            <div class="card-deck">
                                <div class="card border-top">
                                    <div class="card-body">
                                        <h4 class="page-title mt-0">{{'account.billing_cycle' | translate}} <span class="plan-status">{{(subscription?('account.'+subscription?.cycle):'') | translate}}</span></h4>
                                        <hr>
                                        <div class="col-12">
                                            <div class="row mb-2">
                                                <div>{{'account.days_remaining' | translate}}{{remaining_days}}</div>
                                                <div class="progress pd-progress-style1 w-100">
                                                    <div id="progress" class="progress-bar"></div>
                                                </div>
                                                <div class="col-12 text-right p-0 mm-10">{{days_passed}}/{{total_days}}</div>
                                            </div>
                                            <div *ngIf="subscription && (!subscription?.periodCanceled && !nextPeriod?.canceled) && (subscription?.price <= nextPeriod?.price)" class="row m-0">
                                                <button class="btn btn-blue btn-h-blue w-100" (click)="changeBillingCycle()"><strong>{{'account.change_cycle' | translate}}</strong></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card border-top">
                                    <div class="card-body">
                                        <h4 class="page-title mt-0">
                                            {{'account.last_payment' | translate}} 
                                            <span class="plan-trial" *ngIf="subscription?.periodTrial">
                                                {{'account.trial' | translate}}
                                            </span>
                                        </h4>
                                        <hr>
                                        <div *ngIf="subscription">
                                            <div class="row">
                                                <div class="col-12">
                                                    Total  
                                                    <h4>${{currentTotal}}</h4>

                                                      <!-- Message to indicate that the last payment is as of the start of the period/cycle. Upgrade payment not accounted for -->
                                                    <!-- <div class="container text-muted d-flex justify-content-start"> -->
                                                    <div class="row ml-0 mb-2">{{'account.last_payment_message' | translate}}
                                                        <span *ngIf="nextPeriod&&nextPeriod?.paid; else cpm;">{{functionsService.convertUTCDateToLocalDateOnly(nextPeriod?.startDate)}}</span>
                                                        <ng-template #cpm>{{functionsService.convertUTCDateToLocalDateOnly(subscription?.periodStartDate)}}</ng-template>
                                                    </div>
                      
                                                    <!-- <span *ngIf="nextPeriod&&nextPeriod?.paid; else cp;">{{functionsService.convertUTCDateToLocalDateOnly(nextPeriod?.startDate) + " - " + functionsService.convertUTCDateToLocalDateOnly(nextPeriod?.endDate)}}</span>
                                                    <ng-template #cp>{{functionsService.convertUTCDateToLocalDateOnly(subscription?.periodStartDate) + " - " + functionsService.convertUTCDateToLocalDateOnly(subscription?.periodEndDate)}}</ng-template> -->
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <button *ngIf="subscription&&!subscription?.periodTrial" routerLinkActive="active" class="btn btn-blue btn-h-blue w-100" [routerLink]="['view-receipt', (nextPeriod&&nextPeriod?.paid)?(nextPeriod.paymentId):(subscription?.paymentId)]"><strong>{{'account.view_bill' | translate}}</strong></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card border-top" *ngIf="subscription?.nextPeriodId!=0">
                                    <div class="card-body">
                                        <h4 class="page-title mt-0">{{'account.next_invoice' | translate}} 
                                            <span class="plan-status">{{(nextPeriod?.cycle?'account.'+nextPeriod.cycle:"") | translate}}</span>
                                            <span class="plan-status ml-2" *ngIf="nextPeriod?.paid">{{'account.paid' | translate}}</span>
                                        </h4>
                                        <hr>
                                        <div *ngIf="nextPeriod" class="row">
                                            <div class="col-12">
                                                Total
                                                <h4>${{nextTotal?nextTotal:"-"}} <span class="font-small"><i>{{'account.taxes_fees' | translate}}</i></span></h4>
                                                <span *ngIf="!nextPeriod?.paid">{{'account.payment_due' | translate}} {{functionsService.convertUTCDateToLocalDateOnly(nextStartDate)}}<br></span>
                                                {{'account.period' | translate}}: {{functionsService.convertUTCDateToLocalDateOnly(nextPeriod?.startDate) + " - " + functionsService.convertUTCDateToLocalDateOnly(nextPeriod?.endDate)}}
                                            </div> 
                                        </div>
                                        <div *ngIf="!nextPeriod" class="row">
                                            <div class="col-12">
                                                -
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 p-2">
                            <div class="card border-top pb-1">
                                <div class="card-body">
                                    <h4 class="page-title mt-0">{{'account.payment_history' | translate}}</h4>
                                    <hr>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="d-flex flex-row bd-highlight float-right">
                                                <div class="p-2 bd-highlight">
                                                    <label class="mb-0" for="startDate">{{'account.paid_date' | translate}}</label><br>
                                                    <form [formGroup]="receiptDateForm" (ngSubmit)="getPaymentsByRange()">
                                                        <mat-form-field class="mm-10">
                                                            <mat-date-range-input [rangePicker]="picker" formGroupName="picker" [min]='min' [max]='max'>
                                                            <input id="startDate" #fromInput matStartDate formControlName="startDate" matInput readonly>
                                                            <input id="startDate" #toInput matEndDate formControlName="endDate" matInput readonly>
                                                            </mat-date-range-input>
                                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                            <mat-date-range-picker #picker></mat-date-range-picker>
                                                        </mat-form-field>
                                                        <button tabindex="0" class="btn btn-sm remove-filter-btn ml-1" title="" (click)="resetForm()">
                                                            <i class="fa fa-times fa-sm" title="{{ 'general.clear_filter' | translate }}"></i>
                                                        </button>
                                                        <button tabindex="0" mat-raised-button class="btn btn-sm apply-filter-btn ml-1" title="">
                                                            <i class="fa fa-filter fa-xs" title="{{ 'general.apply_filter' | translate }}"></i>
                                                        </button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <table class="w-100" mat-table [dataSource]="dataSource" matSort>
                                                <!-- Period Column -->
                                                <ng-container matColumnDef="periodStartDate">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'account.period' | translate}} </th>
                                                    <td mat-cell *matCellDef="let payment" [attr.role]="null"> {{functionsService.convertUTCDateToLocalDateOnly(payment.periodStartDate)}} - {{functionsService.convertUTCDateToLocalDateOnly(payment.periodEndDate)}} </td>
                                                </ng-container>
                                                <!-- PaidDate Column -->
                                                <ng-container matColumnDef="transactionDate">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'account.paid_date' | translate}} </th>
                                                    <td mat-cell *matCellDef="let payment" [attr.role]="null"> {{functionsService.convertUTCDateToLocalDate(payment.transactionDate)}} </td>
                                                </ng-container>
                                                <!-- Paid Amount Column -->
                                                <ng-container matColumnDef="paidAmount">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'account.paid_amount' | translate}} </th>
                                                    <td mat-cell *matCellDef="let payment" [attr.role]="null"> {{payment?.paidAmount?("$"+functionsService.currencyFormat(payment.paidAmount)):payment?.transactionApproved?"$0.00":"-"}} </td>
                                                </ng-container>
                                                <!-- Transaction Approved Column -->
                                                <ng-container matColumnDef="transactionApproved">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'account.processed' | translate}} </th>
                                                    <td mat-cell *matCellDef="let payment" [attr.role]="null"> {{(payment?.transactionApproved?'general.yes':"No") | translate}} </td>
                                                </ng-container>
                                                <!-- Transaction Status Column -->
                                                <ng-container matColumnDef="transactionStatus">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.status' | translate}} </th>
                                                    <td mat-cell *matCellDef="let payment" [attr.role]="null"> {{(payment?.transactionStatus?payment.transactionStatus:"succeeded") | translate}} </td>
                                                </ng-container>
                                                <!-- Actions Column -->
                                                <ng-container matColumnDef="actions">
                                                    <th mat-header-cell *matHeaderCellDef [attr.role]="null" scope="col"> {{'general.actions' | translate}} </th>
                                                    <td mat-cell *matCellDef="let payment" [attr.role]="null">
                                                        <div *ngIf="payment?.transactionApproved" class="dropdown" ngbDropdown >
                                                            <button ngbDropdownToggle class="btn btn-default dropdown-toggle" title=""> <i class="fa fa-ellipsis-v" title="{{'general.actions' | translate}}"></i></button>
                                                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-left">
                                                                <button ngbDropdownItem *ngIf="payment" [routerLink]="['view-receipt', payment?.id]" routerLinkActive="active" title="{{'account.view_receipt' | translate}}"><i class="fa fa-eye"></i> {{'account.view_receipt' | translate}}</button>
                                                            </div>
                                                        </div>
                                                        <div class="pl-2" *ngIf="payment?.transactionStatus&&payment?.transactionStatus!='succeeded'">
                                                            &nbsp;&nbsp;-
                                                        </div>
                                                    </td>
                                                </ng-container>
                                        
                                                <tr mat-header-row *matHeaderRowDef="displayedColumns" [attr.role]="null"></tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [attr.role]="null"></tr>
                                            </table>
                                            <mat-paginator [pageSizeOptions]="[10, 5, 20]" showFirstLastButtons></mat-paginator>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
